import { render, staticRenderFns } from "./LeaveList.vue?vue&type=template&id=dc697da0"
import script from "../../controllers/teacher_leave/leave-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/teacher_leave/leave-list.js?vue&type=script&lang=js&external"
import style0 from "./LeaveList.vue?vue&type=style&index=0&id=dc697da0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports